<script>
  import CBrow             from "./CBrow.svelte";
  import IoMdPhonePortrait from 'svelte-icons/io/IoMdPhonePortrait.svelte'
  import IoIosMail         from 'svelte-icons/io/IoIosMail.svelte'
  import IoLogoLinkedin    from 'svelte-icons/io/IoLogoLinkedin.svelte'
  import IoLogoFacebook    from 'svelte-icons/io/IoLogoFacebook.svelte'
  import Quote             from "./Quote.svelte"

  let currYear = new Date().getFullYear();
</script>

<style>
  @media screen and (min-width: 1200px) {
    :global(.icontext) {
      font-size: 14px;
    }

    .bottom {
      margin-top: 100px !important;
    }
  }

  @media screen and (max-width: 1199px) {
    :global(.icontext) {
      font-size: 13px;
    }
  }

  @media screen and (max-width: 767px) {
    :global(.icontext) {
      font-size: 14px;
    }
  }

  :global(.icon) {
        color: var(--palette-grad1);
        width: 32px;
        height: 32px;
        display: inline-block;
    }

  :global(.icontext) {
      /* font-size: 14px; */
      font-weight: bold;
      padding-top: 15px;
      z-index: 1;
  }

  .bottom {
    position: relative;
    bottom: 0;
    font-size: 12px;
    font-family: 'Poppins', sans-serif;
    margin-top: 50px;
  }

  .icons{
    padding-top: 15px;
    padding-bottom: 25px;
  }

  .icons>a>.icon {
    margin-right: 15px;
  }
</style>

<span id="contact"></span>
<CBrow bgcolor="var(--palette-grad2)">
  <div slot="left" style="height:100%">
    <div style="height: 100%; position: relative; min-height: 200px;">
      <div class="heading" style="font-size: 30px;">Contact me</div>
      <div class="icontext">
        <a href="tel:+46703311688">
          <div class="icon">
            <IoMdPhonePortrait />
          </div>
          +46 70 33 11 688
        </a>
      </div>
      <div class="icontext">
        <a href="mailto:hello@copperbyte.se">
          <div class="icon">
            <IoIosMail />
          </div>
          hello@copperbyte.se
        </a>
      </div>
      <!-- <div class="icons">
        <a href="http://linkedin.com/company/copperbyte" target="_new">
          <div class="icon">
            <IoLogoLinkedin />
          </div>
        </a>
        <a href="http://facebook.com/copperbyte" target="_new">
          <div class="icon">
            <IoLogoFacebook />
          </div>
        </a>
      </div> -->
      <div class="bottom">
        <img src="/Logo_bg_sm.png" width="170" height="66" alt="Logo" style="margin-bottom: 15px">
        <div class="heading small">Org.no: <span style="color: var(--palette-white)">559297-8844</span></div>
        <div class="heading small">VAT.no: <span style="color: var(--palette-white)">SE559297884401</span></div>
        <div class="heading small">Approved for F-tax</div>
        <div class="heading small">© {currYear}</div>
      </div>
    </div>
  </div>
  <div slot="right" style="width: 100%; height: 100%">
    <div>
      <Quote></Quote>
    </div>
  </div>
</CBrow>